import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export const ProtectedRoute = ({ allowedRole }) => {
  const { currentUser, userProfile, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-background text-foreground space-y-3">
        <Loader2 className="w-8 h-8 animate-spin text-emerald-400" />
        <p className="text-xs font-mono text-muted-foreground">Authenticating session...</p>
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Role validation. Never infer privileges from an email address.
  if (allowedRole) {
    const userRole = userProfile?.role;

    // Fail closed when an authenticated account has no authorized profile.
    if (!userRole) {
      return <Navigate to="/login" state={{ from: location, error: "Your account is not authorized for this portal." }} replace />;
    }

    if ((userRole === "student" || userRole === "admin") && userProfile?.status !== "active") {
      return <Navigate to="/login" state={{ from: location, error: "Your account is currently inactive." }} replace />;
    }

    if (userRole !== allowedRole) {
      if (userRole === "admin") {
        return <Navigate to="/admin" replace />;
      }
      if (userRole === "student") {
        return <Navigate to="/student/dashboard" replace />;
      }
      return <Navigate to="/login" replace />;
    }
  }

  return <Outlet />;
};
